import { Box, styled } from "@mui/material";
import { COLORS } from "assets";

const StyledInputRoot = styled(Box)(({ theme }) => {
  const isLight = theme.palette.mode === "light";
  return `
  border-radius: ${isLight ? COLORS.radius.pill : 10}px;
  color: ${isLight ? COLORS.surface.primaryText : theme.palette.text.secondary};
  background: ${isLight ? COLORS.surface.card : theme.palette.text.primary};
  display: flex;
  align-items: center;
  height: ${isLight ? 40 : 55}px;
  justify-content: center;
  border: ${isLight ? `1px solid ${COLORS.surface.border}` : "none"}!important;
  font-size: ${isLight ? "0.875rem" : "1rem"};
  font-weight: ${isLight ? 500 : 400};
  padding-left: ${isLight ? 16 : 10}px;
  padding-right: ${isLight ? 12 : 0}px;
`;
});
export default StyledInputRoot;
